// src/components/pageContent/PageContent.tsx
import React from "react";
import { Route, Routes } from "react-router-dom";
import { NotebookPageImplementations } from "../page/implementation";
import { AddConnectCardPage } from "../route/addConnectCard";
import { ChatPage } from "../route/chatPage";
import { MarketplacePage } from "../route/marketplace";
import { NotebookRootPage } from "../route/notebookRootPage";
import { NoWorkspacePage } from "../route/noWorkspace";
import { PullConnectorPage } from "../route/pullConnector/pullConnector";
import { PullConnectorTablePage } from "../route/pullConnector/pullConnectorTable";
import { PushConnectorEditPage } from "../route/pushConnector/edit";
import { PushConnectorViewPage } from "../route/pushConnector/view";
import { RootPage } from "../route/rootPage";
import { SelectConnectCardPage } from "../route/selectConnectorType";
import { SettingsPage } from "../route/settings";
import { NotebookPage } from "./notebookPage";

const PageContent: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<RootPage />} />
      <Route path="marketplace" element={<MarketplacePage />} />
      <Route
        path="app/:app-id/app-connector/select-type"
        element={<SelectConnectCardPage />}
      />
      <Route
        path="app/:app-id/app-connector/add"
        element={<AddConnectCardPage />}
      />

      <Route path="/no-workspace" element={<NoWorkspacePage />} />
      <Route path="settings" element={<SettingsPage />} />
      <Route path="newchat" element={<ChatPage />} />
      <Route path="chat/:chatId" element={<ChatPage />} />
      <Route path="app/:app-id/notebook" element={<NotebookRootPage />} />
      <Route path="app/:app-id/page/:page-id" element={<NotebookPage />} />
      <Route
        path="app/:app-id/page/:page-id/implementations"
        element={<NotebookPageImplementations />}
      />
      <Route
        path="app/:app-id/secret/:push-connector-id"
        element={<PushConnectorViewPage />}
      />
      <Route
        path="app/:app-id/secret/:push-connector-id/edit"
        element={<PushConnectorEditPage />}
      />
      <Route
        path="app/:app-id/secret/add"
        element={<PushConnectorEditPage />}
      />
      <Route
        path="app/:app-id/app-connector/:pull-connector-id"
        element={<PullConnectorPage />}
      />
      <Route
        path="app/:app-id/app-connector/:pull-connector-id/table/:table-id"
        element={<PullConnectorTablePage />}
      />
    </Routes>
  );
};

export default PageContent;
